module.exports = __webpack_public_path__ + "static/img/3.dda226d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/vivo/3.png
// module id = 1oxK
// module chunks = 0